import React from 'react'
import { type MetaFunction, Outlet, useOutletContext } from 'react-router'
import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'
import { Footer } from '#app/components/footer'
import { Header } from '#app/components/header.tsx'
import { type Theme } from '#app/utils/theme.server.ts'

export const meta: MetaFunction = ({ location }) => {
	const title = `Support | ${import.meta.env.VITE_APP_TITLE}`
	const description = import.meta.env.VITE_APP_DESCRIPTION
	const url = `https://www.trailviewr.com${location.pathname}`

	return [
		{ title },
		{ name: 'description', content: description },
		{ tagName: 'link', rel: 'canonical', href: url },

		{ property: 'og:type', content: 'website' },
		{ property: 'og:title', content: title },
		{ property: 'og:description', content: description },
		{ property: 'og:url', content: url },
		{
			property: 'og:image',
			content: 'https://www.trailviewr.com/og-default.png',
		},

		{ name: 'twitter:card', content: 'summary_large_image' },
		{ name: 'twitter:title', content: title },
		{ name: 'twitter:description', content: description },
		{ name: 'twitter:url', content: url },
		{ name: 'twitter:site', content: '@TrailViewr' },
		{
			name: 'twitter:image',
			content: 'https://www.trailviewr.com/twitter-card.png',
		},
	]
}

export default function RootLayout() {
	const { theme } = useOutletContext<{ theme: Theme }>()

	return (
		<div className="min-h-screen p-2 md:p-4 lg:p-8">
			<Header className="pb-2 md:pb-4 lg:pb-8" userPreference={theme} />

			<div className="mb-2 flex flex-col">
				<Outlet />
			</div>
			<hr />
			<Footer className="pt-2 md:pt-4 lg:pt-8" />
		</div>
	)
}

export function ErrorBoundary() {
	return <GeneralErrorBoundary />
}
